
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Tagged Template Literals`}</h2>
    <p>{`Tagged Template Literals are a new feature in ES6. They let you define custom string interpolation rules,
which is how we're able to create styled components.`}</p>
    <p>{`If you pass no interpolations, the first argument your function receives is an array with a string in it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// These are equivalent:
fn\`some string here\`;
fn(['some string here']);
`}</code></pre>
    <p>{`Once you pass interpolations, the array contains the passed string, split at the positions of the interpolations.
The rest of the arguments will be the interpolations, in order.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const aVar = 'good';

// These are equivalent:
fn\`this is a \${aVar} day\`;
fn(['this is a ', ' day'], aVar);
`}</code></pre>
    <p>{`This is a bit cumbersome to work with, but it means that we can receive variables, functions, or mixins
(`}<inlineCode parentName="p">{`css`}</inlineCode>{` helper) in styled components and can flatten that into pure CSS.`}</p>
    <p>{`Speaking of which, during flattening, styled-components ignores interpolations that evaluate to `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`, `}<inlineCode parentName="p">{`null`}</inlineCode>{`,
`}<inlineCode parentName="p">{`false`}</inlineCode>{`, or an empty string (`}<inlineCode parentName="p">{`""`}</inlineCode>{`), which means you're free to use
`}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Logical_AND#Short-circuit_evaluation"
      }}>{`short-circuit evaluation`}</a>{`
to conditionally add CSS rules.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Title = styled.h1\`
  /* Text centering won't break if props.upsidedown is falsy */
  \${props.upsidedown && 'transform: rotate(180deg);'}
  text-align: center;
\`;
`}</code></pre>
    <p>{`If you want to learn more about tagged template literals, check out Max Stoiber's article:
`}<a parentName="p" {...{
        "href": "https://mxstbr.blog/2016/11/styled-components-magic-explained/"
      }}>{`The magic behind 💅🏾 styled-components`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;